import React from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ProfessionalOnboarding from './components/ProfessionalOnboarding';
import EmployerOnboarding from './components/EmployerOnboarding';
import ProfessionalHomePage from './components/professional/ProfessionalHomePage';
import EmployerHomePage from './components/employer/EmployerHomePage';
import JobDetails from './components/professional/JobDetails';

import SupportScreen from './components/common/SupportScreen';

import DeleteProfilePage from './components/common/DeleteProfilePage';
import LegalPage from './components/common/LegalPage';
import JobsPage from './components/JobsPage';

// Protected Route wrapper
const ProtectedRoute = ({ user, children, fallback }) => {
  return user ? children : fallback;
};

// Router configuration
export const createAppRoutes = (user, userProfile, navigate) => [
  {
    path: '/',
    element: <LandingPage user={user} userProfile={userProfile} />,
  },
  {
    path: '/signup',
    element: <LandingPage user={user} userProfile={userProfile} />,
  },
  {
    path: '/jobs',
    element: <JobsPage user={user} userProfile={userProfile} />,
  },
  {
    path: '/careers',
    element: <Navigate to="/jobs" replace />,
  },
  {
    path: '/deletemyProfile',
    element: <DeleteProfilePage user={user} />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/onboarding/professional',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <ProfessionalOnboarding
          user={user}
          onComplete={() => navigate('/professional/home')}
        />
      </ProtectedRoute>
    ),
  },
  {
    path: '/onboarding/employer',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <EmployerOnboarding
          user={user}
          onComplete={() => navigate('/employer/home')}
        />
      </ProtectedRoute>
    ),
  },
  {
    path: '/professional/home',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <ProfessionalHomePage user={user} userProfile={userProfile} />
      </ProtectedRoute>
    ),
  },
  {
    path: '/professional/jobs/:jobId',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <JobDetails user={user} />
      </ProtectedRoute>
    ),
  },

  {
    path: '/professional/support',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <SupportScreen user={user} role="professional" />
      </ProtectedRoute>
    ),
  },
  {
    path: '/employer/support',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <SupportScreen user={user} role="employer" />
      </ProtectedRoute>
    ),
  },
  {
    path: '/employer/home',
    element: (
      <ProtectedRoute
        user={user}
        fallback={<Navigate to="/" replace />}
      >
        <EmployerHomePage user={user} userProfile={userProfile} />
      </ProtectedRoute>
    ),
  },
  // Add more routes here as needed
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
